import React from "react";
import { isReported } from "../utils";

type Props = {
  analysis: "CAPE" | "Cuckoo" | "FireEye" | "Joe";
  displayStatus: string | undefined;
};
const ProcessTreeError: React.FC<Props> = ({ analysis, displayStatus }) => {
  if (isReported(displayStatus)) {
    return (
      <>
        <p style={{ fontSize: "1rem", fontWeight: "bold" }}>
          Cannot show behavior data since there is no &apos;processtree&apos; in
          the report
        </p>
        <p style={{ fontSize: "1rem", fontWeight: "normal", marginTop: "5px" }}>
          {analysis} status: {displayStatus}
        </p>
      </>
    );
  }
  return (
    <>
      <p style={{ fontSize: "1rem", fontWeight: "normal" }}>
        Report unavailable
      </p>
      <p style={{ fontSize: "1rem", fontWeight: "normal", marginTop: "5px" }}>
        {analysis} status: {displayStatus || "Report unavailable"}
      </p>
    </>
  );
};

export default ProcessTreeError;
